// Maps article id -> canonical slug (matching tiego.se URL slugs).
// Used for SEO continuity when migrating from tiego.se to tiego.com.
// Both /nyheter/:id and /nyheter/:slug resolve to the same article.
export const newsSlugById: Record<string, string> = {
  "35": "ifrs-lunch",
  "34": "junior-konsult-till-tiego",
  "33": "sa-arbetar-kommuner-praktiskt-med-rkr-r5",
  "32": "junior-utvecklare-till-tiego",
  "31": "tiego-utmanar-kommuner-att-ta-nasta-steg-i-rkr-r5",
  "29": "att-anstlla-potential-vad-gr-man-nr-kandidaten-saknar-cv",
  "30": "revisorns-hjrta-ais-hjrna-och-varfr-fler-ekonomer-borde-tnka-som-skeptiker",
  "27": "hur-bor-kommuner-och-regioner-formulera-en-rfi",
  "25": "tiego-har-erhllit-isae-3402-typ-1",
  "24": "inbjudan-ifrs-18-frndrar-spelplanen-r-du-redo",
  "23": "bttre-rapportflde-och-starkare-verktyg-tga-710-i-fokus-p-anvndardagen",
  "26": "frukostseminarium-med-ynnor-och-tiego",
  "22": "anvndardagen-2025-tle",
  "28": "koncernredovisningssystem-och-rkenskapsinformation",
  "21": "5-r-efter-infrandet-av-ifrs-16-s-funkar-nya-leasingstandarden",
  "21b": "2qb93yxw3chafs98p9pvor3aqbpojc",
  "20": "upphandling-av-koncernrapporteringssystem",
  "20b": "implementera-rkr-r5-fem-steg-fr-framgngsrik-leasingredovisning-i-kommuner",
  "19": "vi-har-ett-nytt-kontor",
  "18": "anvndardagen-2022",
  "17": "ifrs-symposiet-2022-med-mattias-elfgren-amp-tobias-strhle-frn-pwc",
  "16": "finansiell-leasing-enligt-rkr-r5-i-praktiken-p-kommek-2022",
  "15": "redovisning-av-minskningar-enligt-ifrs-16",
  "14": "xbrl-taggning-med-easyx-och-teqnions-rsredovisning-2019-som-exempel",
  "13": "ifric-uttalanden-om-ifrs-16-och-erfarenheter-frn-drift",
  "12": "xbrl-taggning-med-easyx-och-stockwik-frvaltnings-rsredovisning-2019-som-exempel",
  "11": "tle-admin-nyheter",
  "10": "tga-admin-nyheter",
  "9": "koncernrapportering-i-excel-med-bas-inspirerad-kontoplan-hur-lngt-rcker-det",
  "8": "xbrl-taggning-infr-rapportering-till-finansinspektionen-2021-med-easyx-med-en-tiego-kund-som-exempel",
  "7": "bokslutsrutiner-och-kassaflde-enligt-ib-ub-metoden",
  "6": "pdf-1-april-2020-enkt-och-remissvar-pga-nya-ias-1",
  "5": "fljdfrgor-om-jmfrelsestrande-poster-infr-webbinarium",
  "4": "enkt-iasb-infr-live-sndning-av-seminarium",
  "3": "noten-till-ifrs-16-i-praktiken",
  "2b": "erfarenheter-frn-implementation-av-ifrs-16-med-full-retroaktivitet",
  "2": "revisionen-av-ifrs-16-nrmar-sig",
  "1": "erfarenheter-frn-kartlggning-och-driftsttning-av-ifrs-16",
};

export const newsIdBySlug: Record<string, string> = Object.fromEntries(
  Object.entries(newsSlugById).map(([id, slug]) => [slug, id])
);

export function getSlugForArticle(id: string): string {
  return newsSlugById[id] ?? id;
}

export function getIdForParam(param: string): string {
  // If param is a known slug, return its id; otherwise treat as id directly.
  return newsIdBySlug[param] ?? param;
}
